import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
     * turned off by
     * @dynamatic
     * for smooth dynamatic cart experience
  **/
  // open() {
  //   this.showDialog();

  //   /**
  //    * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
  //    */
  //   customElements.whenDefined('shopify-payment-terms').then(() => {
  //     const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
  //     const cta = installmentsContent?.querySelector('#shopify-installments-cta');
  //     cta?.addEventListener('click', this.closeDialog, { once: true });
  //   });
  // }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
